import { Button, Code, Collapse, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { CopyIconButton } from "../../../fix-search/components/CopyButton/CopyIconButton";

export const CodeBlock = ({ children, overrideCopyText = undefined, ...props }) => {
    const [showCopyButton, setShowCopyButton] = useState()

    return <div
        onMouseEnter={() => setShowCopyButton(true)}
        onMouseLeave={() => setShowCopyButton(false)}
        style={{
            position: 'relative'
        }}
    >
        <Code
        whiteSpace='pre'
        borderRadius={5}
        padding={3}
        display='block'
        style={{ 
            textAlign: 'left',
            overflowX: 'scroll' 
        }}
        {...props}
        position='relative'
        minHeight={10}
        boxShadow='inner'
    >
        {children}
        
    </Code>
    <CopyIconButton
        position='absolute'
        visibility={showCopyButton ? 'initial' : 'hidden'}
        top={2}
        right={2}
        size='xs'
        copyText={overrideCopyText ? overrideCopyText : children}
        variant='solid'
        backgroundColor='blackAlpha.200'
    />
    </div>
}

export const CollapsableCodeBlock = ({children, ...props}) => {
    const { isOpen: isShowMore, onToggle: toggleShowMore } = useDisclosure()
    
    if (typeof children === 'string') {
        const numberOfLines = children.split(/\r\n|\r|\n/).length
        if (numberOfLines < 5) {
            return <CodeBlock {...props}>
                {children}
            </CodeBlock>
        }
    }
    
    return <div style={{
        position: 'relative'
    }}>
        <Collapse
            startingHeight={100}
            in={isShowMore}
            style={{
                borderRadius: '5px'
            }}
        >
            <CodeBlock {...props} paddingBottom={6}>
                {children}
            </CodeBlock>
        </Collapse>
        <Button 
          size='xs'
          variant='solid'
          onClick={toggleShowMore}
          background='none'
          borderRadius='5px'
          color='initial'
          bgGradient='linear(to-b, transparent, blackAlpha.600)'
            style={{
                position: 'absolute',
                top: '100%',
                width: '100%',
                right: 0,
                transform: 'translateY(-100%)'
            }}
            _hover={{
                bgGradient: 'linear(to-b, transparent, blackAlpha.700)'
            }}
            _active={{
                bgGradient: 'linear(to-b, transparent, blackAlpha.800)'
            }}
          >
            Show {isShowMore ? 'Less' : 'More'}
        </Button>
    </div>
    
}